module.exports = __webpack_public_path__ + "883fc11206a13fa2c1fa348e57027e9f.png";